import { render, staticRenderFns } from "./EventTimeline.vue?vue&type=template&id=27d67540"
import script from "./EventTimeline.vue?vue&type=script&lang=js"
export * from "./EventTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports